export interface RentalResult {
  monthly: number;
  total: number;
  buyback: number;
}

export function computeRental(subtotalRentable: number, durationMonths: number): RentalResult {
  const monthly = subtotalRentable / 15;
  const total = monthly * durationMonths;
  const buyback = subtotalRentable * 0.2;
  return { monthly, total, buyback };
}
